import { createContext, useEffect, useState, useContext } from 'react'
import {
  db,
  db1,
  ref,
  onValue,
  getDocs,
  collection,
  addDoc,
  auth,
  onAuthStateChanged,
} from 'config/Firebase'

const DataContext = createContext()

const DataContextProvider = ({ children }) => {
  const [user, setUser] = useState({
    isAuth: false,
    isLoading: true,
    data: {},
  })
  const [categories, setCategories] = useState([])
  const [data, setData] = useState([])
  const [clientLinkData , setClientLinksData] = useState([])

  useEffect(() => {

    // const controller = new AbortController()
    // const signal = controller.signal;
    const getData = async () => {
      // get records
      let categoryArray = []
      let projectArray = []
      let linksArray = []
      const storeRef = ref(db, '/category')
      const projectRef = ref(db, '/projects')
      const linkRef = ref(db, '/clientsLink')
      //   get categories
      onValue(storeRef, (snapshot) => {
        categoryArray.splice(0, categoryArray.length)
        snapshot.forEach((val) => {
          const categoryData = val.val()
          const categoryKey = val.key
          categoryData.id = categoryKey
          categoryArray.push(categoryData)
        })
        // console.log(categoryArray)
        setCategories(categoryArray)
      })
      //   get projects

      onValue(projectRef, (snapshot) => {
        projectArray.splice(0, projectArray.length)
        snapshot.forEach((val) => {
          const projectData = val.val()
          const categoryKey = val.key
          projectData.id = categoryKey
          projectArray.push(projectData)
        //   console.log(val.val())
        })
        // console.log(projectArray)
        // setCategories(categoryArray)
        setData(projectArray)
      })

      onValue(linkRef, (snapshot) => {
        linksArray.splice(0, linksArray.length)
        snapshot.forEach((val) => {
          const projectData = val.val()
          const categoryKey = val.key
          projectData.id = categoryKey
          linksArray.push(projectData)
        //   console.log(val.val())
        })
        // console.log(projectArray)
        // setCategories(categoryArray)
        setClientLinksData(linksArray)
      })
      // const categoryRef = ref(db,'')
      // user
      onAuthStateChanged(auth, (user_) => {
        if (user_) {
          setUser({ isAuth: true, isLoading: false, user: user_ })
        } else {
          setUser({ isAuth: false, isLoading: false, user: {} })
        }
      })
    }
    getData()
    //  return()=>{
    //   setCategories([])
    //   controller.abort()
    //  }
    // return getData();
  }, [])

  return (
    <DataContext.Provider
      value={{ data: data, user, categoriesData: categories,clientLinkData }}
    >
      {children}
    </DataContext.Provider>
  )
}

export const useData = () => useContext(DataContext)

export default DataContextProvider
